/* eslint-disable camelcase */
import { env } from '@/constant';
import { isBaseInfoType, isOptionsType } from './hooks';
import { BaseInfoType, OptionsType } from './types';

export const ubtCheck = (
  /* 必填 - 基础信息 */
  baseInfo: BaseInfoType,
  /* 选填 - 额外参数信息 */
  options?: OptionsType,
): BaseInfoType & OptionsType => {
  if (env === 'fat') {
    try {
      isBaseInfoType(baseInfo);
      isOptionsType(options);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  // 校验成功 - 通过上述规则校验
  return {
    ...baseInfo,
    ...(options || {}),
  };
};
